module.exports = __webpack_public_path__ + "30b78a08f627bfd5f8108ab9ca3c6f4b.jpg";